<template>
  <v-list-item>
    <!--    <v-list-item-avatar v-if="model">-->
    <!--      <v-avatar>-->
    <!--        <v-img :src="model.path" />-->
    <!--      </v-avatar>-->
    <!--    </v-list-item-avatar>-->

    <v-list-item-content>
      <span v-if="!model">{{ label }}</span>
      <a
        v-else
        target="_blank"
        :href="model.path"
      >{{ fileTile || 'Открыть файл' }}</a>
    </v-list-item-content>
    <v-list-item-action v-if="!disabled">
      <v-btn
        v-if="model"
        small
        color="error"
        outlined
        rounded
        icon
        @click.stop="onDeleteFile"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <WBDFileUploaderBtn
        v-else
        :small="small"
        :label="btnLabel"
        :loaded-event="eventNames.DICTIONARY_AVATAR_UPLOADED"
        :deleted-event="eventNames.DICTIONARY_AVATAR_DELETED"
        :file-key="alias"
        :extra-set="extraData"
        :mime-types="mimeTypes"
        :callback="onFileSaved"
        :icon="icon"
      />
    </v-list-item-action>
  </v-list-item>
</template>
<script>
import WBDFileUploaderBtn from '@/components/common/files/file-uploader-btn'


export default {
  name: 'WBDFileUploader',
  components: { WBDFileUploaderBtn },
  props: {
    label: {
      type: String,
      default: 'Добавить картину'
    },
    showMode: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    alias: {
      type: String,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    btnLabel: {
      type: String,
    },
    model: {
      type: Object,
    },
    extraData: {
      type: Object,
    },
    small: {
      type: Boolean,
    },
    mimeTypes: {
      type: String,
      default: 'image/*'
    },
    fileTile: {
      type: String,
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {
    onFileSaved (response) {
      this.$emit('onFileSaved', { alias: this.alias, file: response })
    },
    onDeleteFile () {
      this.$emit('onFileDeleted', this.alias)
    }
  }
}
</script>
